import React from 'react'
import styled from 'styled-components/macro'

import margin from '../../styles/margin'

const getColor = (props) => {
  if (props.fade) {
    return props.theme.colors.grey.grey5
  } else if (props.white) {
    return props.theme.colors.grey.white
  } else {
    return props.theme.colors.grey.grey9
  }
}

const Component = styled.p`
  ${margin};

  font-family: 'Pluto Sans', sans-serif;
  font-weight: bold;
  font-size: ${(props) => (props.bigger ? '16px' : '12px')};
  line-height: 12px;
  text-transform: ${(props) => (props.noUpper ? 'none' : 'uppercase')};
  /* 2px is not in general theme size */
  letter-spacing: 2px;
  color: ${(props) => getColor(props)};
  margin-bottom: ${(props) => 4 * props.mb}px;
  margin-top: ${(props) => 4 * props.mt}px;
  text-align: ${(props) => (props.center ? 'center' : 'left')};
`

const Overline = ({ children, ...styles }) => (
  <Component {...styles}>{children}</Component>
)

export default Overline
